import { QueryClient } from '@tanstack/react-query';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { persistQueryClient } from '@tanstack/react-query-persist-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      // Keep data in cache for 24h so offline reloads have something to show.
      gcTime: 1000 * 60 * 60 * 24,
    },
  },
});

/**
 * Persist TanStack Query cache to localStorage. After a good online session,
 * the next offline launch will rehydrate from disk and render instantly
 * with last-known data while the SW handles the API fallback.
 *
 * Safe to call at module load: SSR-ness is guarded inside the helper.
 */
if (typeof window !== 'undefined') {
  const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: 'gpl.mobile.qc',
    throttleTime: 1000,
  });
  persistQueryClient({
    queryClient,
    persister,
    maxAge: 1000 * 60 * 60 * 24, // 24h
    buster: '1', // bump this when query shapes change to force a clean rehydrate
  });
}
